module.exports = __webpack_public_path__ + "img/banned.cd47ca09.svg";